import axios from 'axios'

const state = {
  regions: [],
  singleRegion: null,
  currentRegion: null,
}

const getters = {
  getRegions (state) {
    return state.regions
  },
  getSingleRegion (state) {
    return state.singleRegion
  },
}

const mutations = {
  setRegions (state, payload) {
    state.regions = payload
  },
  setSingleRegion (state, payload) {
    state.singleRegion = payload
  },
  clearSingleRegion (state) {
    state.singleRegion = null
  },
}

const actions = {
  fetchRegions ({ commit, rootGetters }, meta) {
    return axios
      .get(rootGetters['api/regionsList'], {
        params: meta,
      })
      .then((res) => {
        commit('setRegions', res.data.items)
        return res.data.items
      })
  },
  fetchSingleRegion ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/regionsSingle'](id))
      .then((res) => {
        commit('setSingleRegion', res.data.data)
        return res.data.data
      })
  },
  createRegion ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/regionsCreate'], data)
      .then((res) => {
        return res
      })
  },
  editRegion ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/regionsEdit'](id), data)
  },
  deleteRegion ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/regionsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getRegions.filter((val) => val.id !== id)
          commit('setRegions', items)
        }

        return res
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
